"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAMPAIGN_FINDER_LIMIT = void 0;
exports.CAMPAIGN_FINDER_LIMIT = 12;
